import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-rangeslider";
import axios from "axios";
import { useForm } from "react-hook-form";
import { onSendOtp, onVerifyOtp } from "../service/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { callLSQLapp, getLsqLeadBody, encryptBody } from "../service/lsq";

// import moment from "moment";
import { useCookies } from "react-cookie";
import queryString from "query-string";
import { notifySuccess, notifyWarn } from "../service/Toastifyfn";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ReCAPTCHA from "react-google-recaptcha";

import "react-rangeslider/lib/index.css";
import "../App.css";

const FormComponent = ({ }) => {
  const navigate = useNavigate();
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [Garduation, setGarduation] = useState("Yes");
  const [GarduationStream, setGarduationStream] = useState("");
  const [experienceYears, setExperienceYears] = useState("");
  const [experienceMonths, setExperienceMonths] = useState("");
  const [percentage, setPercentage] = useState();
  const [tenpercentage, setTenPercentage] = useState();
  const [twelvepercentage, setTwelvePercentage] = useState();
  const [pincode, setPincode] = useState();
  const [mobileNo, setmobileNo] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [disableStatus, setDisableStatus] = useState(false);
  const [dob, setdob] = useState();
  const [otpStatus, setOtpStatus] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const inputOtpReference = useRef(null);
  // const [Terms, setTerms] = useState(null);
  // const Onsetterms = (e) => { setTerms(e.target.checked); };
  const [formErrors, setformErrors] = useState({});
  const [otpToken, setOTPtoken] = useState("");
  const [disableFields, setDisableFields] = useState(false);
  // const [communicationConsent, setCommunicationConsent] = useState(""); // "Yes" | "No"
  // const [dataProcessingConsent, setDataProcessingConsent] = useState(""); // "Yes" | "No"
  // const consentYes = communicationConsent === "Yes" && dataProcessingConsent === "Yes";

  const [communicationConsent, setCommunicationConsent] = useState(false);
  const [dataProcessingConsent, setDataProcessingConsent] = useState(false);
  const consentYes = communicationConsent && dataProcessingConsent;
  const [tenError, setTenError] = useState("");
  const [gradError, setGradError] = useState("");


  const [Validationerrors, setErrors] = useState({
    firstnameerror: { error: false, message: "", type: "" },
    lastnameerror: { error: false, message: "", type: "" },
    emailerror: { error: false, message: "", type: "" },
    doberror: { error: false, message: "", type: "" },
    Garduationerror: { error: false, message: "", type: "" },
    GraduationStreamerror: { error: false, message: "", type: "" },
    percentageerror: { error: false, message: "", type: "" },
    pincodeerror: { error: false, message: "", type: "" },
    mobileerror: { error: false, message: "", type: "" },
    // termserror: { error: false, message: "", type: "" },
    communicationConsentError: { error: false, message: "", type: "" },
    dataProcessingConsentError: { error: false, message: "", type: "" },
    othererror: { error: false, message: "", type: "" },
    tenpercentageerror: { error: false, message: "", type: "" },
    twelvepercentageerror: { error: false, message: "", type: "" },
    ExperienceYearserror: { error: false, message: "", type: "" },
    ExperienceMonthserror: { error: false, message: "", type: "" },
  });

  //lsq
  const [cookies, setCookie] = useCookies();
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [utmDetails, setUtmDetails] = useState({});
  const [otpVal, setOtpVal] = useState("");
  const [applyNow, setApplyNow] = useState(false);
  const [otpsent, setOtpsent] = useState(false);

  let cancelToken;
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
  } = useForm();

  const onFNameChange = (e) => {
    const re = /^[a-zA-Z\s]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setFirstname(e.target.value);
    }
  };

  const onLastNameChange = (e) => {
    const re = /^[a-zA-Z\s]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setLastname(e.target.value);
    }
  };

  const onEmailChanges = (e) => {
    let emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var pattern = new RegExp(emailRegex);

    if (!e.target.value) {
      setErrors({
        emailerror: {
          error: true,
          message: "Please enter valid Email",
          type: "required",
        },
      });
      setEmail(e.target.value);
      return;
    } else if (!pattern.test(e.target.value)) {
      setErrors({
        emailerror: {
          error: true,
          message: "Invalid email format",
          type: "required",
        },
      });
      setEmail(e.target.value);
      return;
    } else {
      // Clear error if the email is valid
      setErrors({
        emailerror: { error: false, message: "", type: "" },
      });
      setEmail(e.target.value);
    }
  };

  const onPercentageChanges = (e) => {
    if (e.target.value != "") {
      setPercentage(e.target.value);
      return;
    }
    setErrors({
      percentageerror: { error: false, message: "", type: "" },
    });
    setPercentage(e.target.value);
  };


  // const onStreamChanges = (e) => {
  //   if (!e.target.value) {
  //     setErrors({
  //       GraduationStreamerror: {
  //         error: true,
  //         message: "Please select Graduation Type",
  //         type: "required",
  //       },
  //     });
  //     setGarduationStream(e.target.value);
  //     return;
  //   } else {
  //     // Clear error if Graduation Type
  //     setErrors({
  //       GraduationStreamerror: { error: false, message: "", type: "" },
  //     });
  //     setGarduationStream(e.target.value);
  //   }
  // };

  // const Onsetterms = (e) => {
  //   setTerms(e.target.checked);
  // };

  // ---- Photo page redirect handler ----
  // When the photo page finishes, it can't navigate to /thank-you directly
  // (S3 returns Access Denied). Instead it sets a localStorage flag and
  // redirects to "/". This useEffect picks up the flag and uses React Router
  // to navigate to the correct thank-you page.
  useEffect(() => {
    const redirect = localStorage.getItem("aspire_redirect");
    const redirectId = localStorage.getItem("aspire_redirect_id");
    if (redirect) {
      localStorage.removeItem("aspire_redirect");
      localStorage.removeItem("aspire_redirect_id");
      navigate(redirectId ? `${redirect}?id=${redirectId}` : redirect);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setFbp(cookies["_fbp"] === undefined ? "" : cookies["_fbp"]);
    setFbc(cookies["_fbc"] === undefined ? "" : cookies["_fbc"]);

    // set UTM parameters
    const getUTMDetails = queryString.parse(window.location.search);

    setUtmDetails(getUTMDetails);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---- Stale lead recovery ----
  // If user returns to the form page and there's leftover aspire_lead_id + aspire_form_data
  // (meaning they closed the browser on the photo page), call HireCraft without photo
  // and update the existing LSQ lead.
  useEffect(() => {
    const recoverStaleLead = async () => {
      const leadId = localStorage.getItem("aspire_lead_id");
      const formDataStr = localStorage.getItem("aspire_form_data");
      const photoSubmitted = localStorage.getItem("aspire_photo_submitted");

      if (!leadId || !formDataStr || photoSubmitted === "true") {
        // Clean up any partial state
        if (leadId || formDataStr) {
          localStorage.removeItem("aspire_lead_id");
          localStorage.removeItem("aspire_form_data");
          localStorage.removeItem("aspire_form_timestamp");
          localStorage.removeItem("aspire_photo_submitted");
          localStorage.removeItem("aspire_hc_status");
        }
        return;
      }

      try {
        const object = JSON.parse(formDataStr);
        object.leadId = leadId;
        const encrypted = await encryptBody(object);
        // Call HireCraft (no photo) + update existing LSQ lead
        await callLSQLapp(encrypted, "HIRECRAFT", { key: "hireCraftAndUpdate" });
        console.log("Stale lead recovery: HireCraft called for lead", leadId);
      } catch (err) {
        console.error("Stale lead recovery failed:", err);
      }

      // Clean up regardless of success/failure — lead is safe in LSQ
      localStorage.removeItem("aspire_lead_id");
      localStorage.removeItem("aspire_form_data");
      localStorage.removeItem("aspire_form_timestamp");
      localStorage.removeItem("aspire_photo_submitted");
      localStorage.removeItem("aspire_hc_status");
    };
    recoverStaleLead();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---- Shared fallback submitter (Path B + Path C) ----
  // Sends the lead to HIRECRAFT without a photo.
  // If HIRECRAFT fails, falls back to LSQ CREATE so the lead is never lost.
  const submitFallbackLead = async (object, encryptBody, callLSQLapp, getLsqLeadBody, navigate) => {
    try {
      const encryptedFallback = await encryptBody(object);
      // key: "noPhotoFallback" tells the Lapp this is a timer/browser-close fallback
      // so it tags mx_Photo_Submitted = "No" in LSQ for easy filtering
      const fallbackLead = await callLSQLapp(encryptedFallback, "HIRECRAFT", { key: "noPhotoFallback" });
      const msg = fallbackLead?.data?.message;

      localStorage.removeItem("aspire_form_data");
      localStorage.removeItem("aspire_form_timestamp");
      localStorage.removeItem("aspire_photo_submitted");

      if (msg && msg.message !== "Failure occured , please check logs") {
        const lead_ID = msg.id;
        const hireExpertStatus = msg.hireCraftStatusCode;
        if (hireExpertStatus === 101) {
          navigate(`thankYouTwo?id=${lead_ID}`);
        } else if (hireExpertStatus === 100) {
          navigate(`thank-you?id=${lead_ID}`);
        }
      } else {
        // HIRECRAFT failed — LSQ CREATE as last resort
        const payload = {
          mobile: object.mobile,
          otp: object.otp,
          formdata: getLsqLeadBody(object),
        };
        const encryptedPayloadData = await encryptBody(payload);
        const lsqLead = await callLSQLapp(encryptedPayloadData, "CREATE", { productType: "careers" });
        const leadid = lsqLead?.data?.message?.Data?.LeadApiCalls?.Message?.Id;
        navigate(`thankYouThree?id=${leadid}`);
      }
    } catch (err) {
      console.error("submitFallbackLead failed:", err);
    }
  };

  // const ValidateDate = (e) => {
  //   debugger;
  //   const regexddmmyyyy = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
  //   if (regexddmmyyyy.test(e.target.value)) {
  //     const datanew = new Date(e.target.value);
  //     setdob(datanew.toDateString());
  //     setErrors({
  //       doberror:{error:false,message:"Invalid Date",type:"required"}
  //     })
  //   } else {
  //     setdob("");
  //     setErrors({
  //       doberror:{error:true,message:"Invalid Date",type:"required"}
  //     })
  //   }

  // };

  const handleBlur = async (event) => {
    const name = event.target.name;
    const value = event.target.value;
    let emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (name === "email") {
      // Regular expression for email validation
      var pattern = new RegExp(emailRegex);

      if (!value) {
        setErrors({
          emailerror: {
            error: true,
            message: "Please enter valid Email",
            type: "required",
          },
        });
        // setemail("Please enter your email.");
      } else if (!pattern.test(value)) {
        setErrors({
          emailerror: {
            error: true,
            message: "Invalid email format",
            type: "required",
          },
        });
        return false;
      } else {
        // Clear error if the email is valid
        setErrors({
          emailerror: { error: false, message: "", type: "" },
        });
      }
    }
  };

  const ValidateForm = () => {
    if (firstname === "" || firstname == undefined) {
      setErrors({
        firstnameerror: {
          error: true,
          message: "Please enter First Name",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        firstnameerror: {
          error: false,
          message: "Please enter First Name",
          type: "",
        },
      });
    }

    if (lastname === "" || lastname == undefined) {
      setErrors({
        lastnameerror: {
          error: true,
          message: "Please enter Last Name",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        lastnameerror: {
          error: false,
          message: "Please enter First Name",
          type: "",
        },
      });
    }

    if (email === "" || email == undefined) {
      setErrors({
        emailerror: {
          error: true,
          message: "Please enter Email",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        emailerror: { error: false, message: "Please enter Email", type: "" },
      });
    }

    if (dob === "" || dob == undefined) {
      setErrors({
        doberror: {
          error: true,
          message: "Please Select DOB",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        doberror: {
          error: false,
          message: "Please enter First Name",
          type: "",
        },
      });
    }
    if (Garduation === "" || Garduation == undefined) {
      setErrors({
        Garduationerror: {
          error: true,
          message: "Please Select Graduation",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        Garduationerror: {
          error: false,
          message: "Please enter First Name",
          type: "",
        },
      });
    }

    // if (GarduationStream === "" || GarduationStream === undefined) {
    //   setErrors({
    //     GraduationStreamerror: {
    //       error: true,
    //       message: "Please select Graduation Type",
    //       type: "required",
    //     },
    //   });
    //   return false;
    // } else {
    //   setErrors({
    //     GraduationStreamerror: { error: false, message: "", type: "" },
    //   });
    // }

    //----------------------------------------------------------------------

    if (tenpercentage === "" || tenpercentage == undefined) {
      setErrors({
        tenpercentageerror: {
          error: true,
          message: "Please enter Class 10th percentage",
          type: "required",
        },
      });
      return false;
    } else if (Number(tenpercentage) < 0) {
      setErrors({
        tenpercentageerror: {
          error: true,
          message: "Percentage cannot be negative",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        tenpercentageerror: { error: false, message: "", type: "" },
      });
    }

    //----------------------------------------------------------------------
    // ----------------------
    // Class 12th marks validation
    // ----------------------
    if (twelvepercentage === "" || twelvepercentage == undefined) {
      setErrors({
        twelvepercentageerror: {
          error: true,
          message: "Please enter Class 12th percentage",
          type: "required",
        },
      });
      return false;
    } else if (Number(twelvepercentage) < 0) {
      setErrors({
        twelvepercentageerror: {
          error: true,
          message: "Percentage cannot be negative",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        twelvepercentageerror: { error: false, message: "", type: "" },
      });
    }

    // graduation percentage validation

    if (percentage === "" || percentage == undefined) {
      setErrors({
        percentageerror: {
          error: true,
          message: "Please enter percentage",
          type: "required",
        },
      });
      return false;
    } else {
      if (percentage === "") {
        setErrors({
          percentageerror: {
            error: true,
            message: "Please Enter graduation percentage",
            type: "required",
          },
        });
        return;
      } else {
        setErrors({
          percentageerror: { error: false, message: "", type: "" },
        });
      }
    }


    // Experience validation


    // Experience - Years Validation
    if (experienceYears === "" || experienceYears === undefined) {
      setErrors({
        ExperienceYearserror: {
          error: true,
          message: "Please select Experience (Years)",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        ExperienceYearserror: { error: false, message: "", type: "" },
      });
    }





    // Experience - Months Validation
    if (experienceMonths === "" || experienceMonths === undefined) {
      setErrors({
        ExperienceMonthserror: {
          error: true,
          message: "Please select Experience (Months)",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        ExperienceMonthserror: { error: false, message: "", type: "" },
      });
    }

    // Ensure months does not exceed 11
    if (Number(experienceMonths) > 11) {
      setErrors({
        ExperienceMonthserror: {
          error: true,
          message: "Months cannot exceed 11",
          type: "required",
        },
      });
      return false;
    }




    //------------------------
    if (pincode === "" || pincode == undefined) {
      setErrors({
        pincodeerror: {
          error: true,
          message: "Please enter pincode",
          type: "required",
        },
      });
      return false;
    } else {
      if (pincode.length < 6) {
        setErrors({
          pincodeerror: {
            error: true,
            message: "Please enter valid pincode",
            type: "required",
          },
        });
        return false;
      } else {
        setErrors({
          pincodeerror: { error: false, message: "", type: "" },
        });
      }
    }
    debugger;
    if (mobileNo === "" || mobileNo == undefined) {
      setErrors({
        mobileerror: {
          error: true,
          message: "Please enter mobile no",
          type: "required",
        },
      });
      return false;
    } else {
      if (mobileNo.length < 10) {
        setErrors({
          mobileerror: {
            error: true,
            message: "Please enter valid mobile no.",
            type: "required",
          },
        });
        return false;
      } else {
        setErrors({
          mobileerror: { error: false, message: "", type: "" },
        });
      }
    }
    // if (Terms === "" || Terms == undefined || Terms == false) {
    //   setErrors({
    //     termserror: {
    //       error: true,
    //       message: "Please accept terms",
    //       type: "required",
    //     },
    //   });
    //   return false;
    // } else {
    //   setErrors({
    //     termserror: { error: false, message: "", type: "" },
    //   });
    // }
    // Disclaimer 1 mandatory
    if (!communicationConsent) {
      setErrors({
        communicationConsentError: {
          error: true,
          message: "Please select Yes/No",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        communicationConsentError: { error: false, message: "", type: "" },
      });
    }

    // Disclaimer 2 mandatory
    if (!dataProcessingConsent) {
      setErrors({
        dataProcessingConsentError: {
          error: true,
          message: "Please select Yes/No",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        dataProcessingConsentError: { error: false, message: "", type: "" },
      });
    }

    if (!otpVerified) {
      // if (otpVerified) {
      setErrors({
        othererror: {
          error: true,
          message: "Click Get OTP to continue",
          type: "required",
        },
      });
      return false;
    } else {
      setErrors({
        othererror: { error: false, message: "", type: "" },
      });
    }



    return true;
  };

  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const onSubmitForm = async (obj) => {
    setSubmitted(true);
    if (ValidateForm()) {
      triggerApplyGtags();
      setApplyNow(true);

      if (otpVerified) {
        let dateOfBirth = new Intl.DateTimeFormat("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }).format(dob);
        // Rearrange the formatted date to "year-month-day"
        dateOfBirth = dateOfBirth.split("/").reverse().join("-");
        var object = {
          FirstName: firstname,
          LastName: lastname,
          email: email,
          dob: dateOfBirth,
          gradStatus: Garduation,
          // graduationType: GarduationStream,
          percentage: percentage,
          pincode: pincode,
          mobile: mobileNo,
          otp: otpVal,
          uniqueToken: otpToken,
          CompleteUrl: window.location.href,
          Gclid: utmDetails.gclid,
          utm_campaign: utmDetails.utm_campaign,
          utm_content: utmDetails.utm_content,
          utm_lms: utmDetails.utm_lms,
          AdType: utmDetails.utm_medium,
          SearchEngine: utmDetails.utm_source,
          Keyword: utmDetails.utm_term,
          UTM_Content: utmDetails.utm_content,
          Product: "careers",
          ModeOfLead: "landing-page",
          User_Agent: navigator.userAgent,
          Referral: document.referrer,
          tenthPercentage: tenpercentage,
          // iConsent: Terms,
          iConsent: consentYes,
          dataProcessConsent: dataProcessingConsent,
          overallWorkExperienceYears: experienceYears,
          overallWorkExperienceMonths: experienceMonths,
          twelvePercentage: twelvepercentage,
        };
        let param = {};
        console.log("object", object);
        const encryptedPayload = await encryptBody(object);
        console.log("encryptedPayload", encryptedPayload);
        let CreateLsqlead
        // if(Number(percentage) < 60)
        if (
          Garduation === "No" ||
          Number(percentage) < 60 ||
          Number(tenpercentage) < 60 ||
          Number(twelvepercentage) < 50 ||
          (Number(experienceYears || 0) * 12 + Number(experienceMonths || 0)) > 24
        ) {
          let payload = {
            mobile: mobileNo,
            otp: otpVal,
            formdata: getLsqLeadBody(object),
          };
          let param = { productType: "careers" };
          const encryptedPayloadData = await encryptBody(payload);
          CreateLsqlead = await callLSQLapp(encryptedPayloadData, "CREATE", param);
          let leadid = CreateLsqlead.data.message.Data.LeadApiCalls.Message.Id;
          navigate(`thankYouThree?id=${leadid}`);
        } else {
          const isMobile = window.innerWidth <= 1024;
          if (isMobile) {
            // MOBILE: Create LSQ lead immediately (HireCraft called later from photo page)
            object.photoSubmitted = "No"; // mx_Hire = "No" initially
            let createPayload = {
              mobile: mobileNo,
              otp: otpVal,
              formdata: getLsqLeadBody(object),
            };
            let createParam = { productType: "careers" };
            const encryptedCreatePayload = await encryptBody(createPayload);
            try {
              const createResult = await callLSQLapp(encryptedCreatePayload, "CREATE", createParam);
              const leadId = createResult.data.message.Data.LeadApiCalls.Message.Id;

              // Save form data + lead ID so photo page can call HireCraft later
              localStorage.setItem("aspire_lead_id", leadId);
              localStorage.setItem("aspire_form_data", JSON.stringify(object));
              localStorage.setItem("aspire_form_timestamp", Date.now().toString());
              localStorage.removeItem("aspire_photo_submitted");

              window.location.href = "Photo%20Collecting%20Page/index.html";
            } catch (err) {
              console.error("Mobile LSQ lead creation failed:", err);
              setApplyNow(false);
              notifyWarn("Error occurred, Please try after sometime.");
            }
          } else {
            // DESKTOP: HireCraft + LSQ in one shot (original flow)
            CreateLsqlead = await callLSQLapp(
              encryptedPayload,
              "HIRECRAFT",
              param
            );
            if (
              CreateLsqlead.data.message.message !==
              "Failure occured , please check logs"
            ) {
              let lead_ID = CreateLsqlead.data.message.id;
              let hireExpertStatus = CreateLsqlead.data.message.hireCraftStatusCode;
              if (hireExpertStatus === 101) {
                navigate(`thankYouTwo?id=${lead_ID}`);
              } else if (hireExpertStatus === 100) {
                navigate(`thank-you?id=${lead_ID}`);
              } else {
                notifyWarn("error occurred");
              }
            } else {
              setApplyNow(false);
              notifyWarn("Error occurred, Please try after sometime.");
            }
          }
        }
      } else {
        if (otpStatus == false) {
          setOtpVerified(false);
          return;
        }
      }

      // navigate(`thank-you`);
    }
  };

  const onOtpKeyHandler = (event) => {
    if (!`${event.target.value}${event.key}`.match(/^[0-9]{0,6}$/)) {
      // block the input if result does not match
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  };

  const TriggerOTPTags = () => {
    window.fbq("init", "{1584375811875352}");
    window.fbq("track", "HR-Aspire-Get-OTP");
    window.gtag("event", "conversion", {
      send_to: "AW-10917910622/MTKUCPGr78kbEN6wiNYo",
    });
    window.lintrk('track', { conversion_id: 26953761 });
  };

  const triggerApplyGtags = () => {
    window.fbq("init", "{1584375811875352}");
    window.fbq("track", "HR-Aspire-Apply-Now");
    window.gtag("event", "conversion", {
      send_to: "AW-10917910622/LdfmCO6r78kbEN6wiNYo",
    });
    window.lintrk('track', { conversion_id: 26953777 });

    // PO2-Lead-Submit tags
    window.fbq('track', 'PO2-Lead-Submit');
    window.gtag('event', 'conversion', {
      'send_to': 'AW-10917910622/3HySCJ6-478cEN6wiNYo',
    });
    window.lintrk('track', { conversion_id: 28891633 });
  };

  // PO2-Photo-Submit tags - call this function when photo is submitted
  const triggerPhotoSubmitGtags = () => {
    window.fbq("init", "{1584375811875352}");
    window.fbq('track', 'PO2-Photo-Submit');
    window.gtag('event', 'conversion', {
      'send_to': 'AW-10917910622/gxwcCKG-478cEN6wiNYo',
    });
    window.lintrk('track', { conversion_id: 28891641 });
  };

  const sendOtp = async (mobile) => {
    if (!mobileNo) {
      if (mobileNo === "" || mobileNo == undefined) {
        setErrors({
          mobileerror: {
            error: true,
            message: "Please enter mobile no",
            type: "required",
          },
        });
        return false;
      } else {
        setErrors({
          mobileerror: { error: false, message: "", type: "required" },
        });
      }
    }
    if (mobileNo.length === 10) {
      try {
        setOtpsent(true);
        let payload = { mobile: mobile, messageType: "otpGeneral" };
        let param = { otp: "send", productType: "careers" };
        const res = await callLSQLapp(payload, "OTP", param);
        // const res = await onSendOtp(mobileNo);

        // The lapp responded (didn't throw) - see what it actually said
        // instead of assuming the "success" shape blindly.
        const lappResult = res?.data?.message;
        const sendResult =
          lappResult && typeof lappResult === "object" ? lappResult.response : null;

        if (sendResult && typeof sendResult === "object" && sendResult.sent) {
          notifySuccess("An OTP has been sent to your Mobile number");
          TriggerOTPTags();
          setOtpStatus(true);
          setSeconds(30);
        } else {
          // Lapp responded but did not confirm the OTP was actually sent
          // (invalid number / limit reached / OTP gateway didn't confirm in
          // time). Surface the real reason when we have one instead of a
          // generic message, and make sure we don't leave the UI stuck on
          // "Sending...".
          setOtpsent(false);
          const reason = typeof sendResult === "string" ? sendResult : null;
          notifyWarn(reason || "Error occured while generating OTP.");
        }
      } catch (error) {
        // The request to lapp-proxy itself never got a usable response
        // (network drop, timeout, etc.) - this is the case that can show an
        // error even though the OTP SMS was already dispatched server-side.
        setOtpsent(false);
        notifyWarn("Error occured while generating OTP.");
      }
    }
  };

  const verifyOtp = async (e) => {
    if (!mobileNo) {
      notifyWarn("please enter mobile number");
      return;
    }
    if (!e.target.value) {
      e.preventDefault();
      return;
    }
    if (e.target.value.length > 5) {
      try {
        // const res = await onVerifyOtp(mobileNo, e.target.value);
        let payload = { mobile: mobileNo, otp: e.target.value };
        let param = { otp: "verify", productType: "careers" };
        const res = await callLSQLapp(payload, "OTP", param);

        const lappMessage = res?.data?.message;
        const verifyResult =
          lappMessage && typeof lappMessage === "object" ? lappMessage.response : null;

        if (!verifyResult || typeof verifyResult !== "object" || !verifyResult.verified) {
          notifyWarn("Please enter valid OTP");
          // document.getElementsByName("otpInput")[0].focus();
          document.getElementsByName("otpInput")[0].focus();
          document.getElementsByName("otpInput")[0].value = "";
          // setErrors({
          //   othererror:{error:false,message:"",type:"required"}
          //  } )
          return false;
        } else {
          setOtpVal(e.target.value);
          // e.target.value = "";
          notifySuccess("OTP is verified");
          setDisableStatus(true);
          setSeconds(0);
          const tokenValue = verifyResult.dataSent?.UniqueID;
          setOTPtoken(tokenValue);
          setOtpVerified(true);
          // setErrors({
          //   othererror:{error:false,message:"",type:"required"}
          //  } )
        }
      } catch (error) {
        // request to lapp-proxy itself failed - keep the field enabled so
        // the user can retry instead of silently getting stuck.
        setOtpVerified(false);
        setDisableStatus(false);
      }
    }
  };
  const currentDate = new Date(); // Get the current date

  const maxDate = new Date(); // Create a new date object
  maxDate.setFullYear(currentDate.getFullYear() - 19);

  const minDate = new Date(); // Create a new date object
  minDate.setFullYear(currentDate.getFullYear() - 25);

  const handleGraduationBox = (e) => {
    setGarduation(e.target.value);
    if (e.target.value === "No") {
      console.log("not eligible");
      window.alert("You are not eligible for the ICICI Bank Aspire programme");
      setDisableFields(true);
    } else {
      setDisableFields(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  return (
    <>

      <form noValidate className="form">
        <div className="careerform">
          <div className="form--head">
            <h3>Get ready to start your banking career</h3>

          </div>
          <div className="form--content">
            <div className="row">
              <div className="col-6">
                <div className="field">
                  <input
                    type="text"
                    className="form-control inputTextBox"
                    placeholder="First Name*"
                    id="firstname"
                    name="firstname"
                    value={firstname}
                    autoComplete="off"
                    onChange={(e) => onFNameChange(e)}
                  />
                  {Validationerrors.firstnameerror ? (
                    <>
                      {Validationerrors.firstnameerror.type === "required" && (
                        <span className="error-msg">
                          {Validationerrors.firstnameerror.message}
                        </span>
                      )}
                      {Validationerrors.firstnameerror.type === "minLength" && (
                        <span className="error-msg">
                          {Validationerrors.firstnameerror.message}
                        </span>
                      )}
                    </>
                  ) : null}
                </div>

              </div>
              <div className="col-6">
                <div className="field">
                  <input
                    type="text"
                    className="form-control inputTextBox"
                    placeholder="Last Name*"
                    id="lastname"
                    name="lastname"
                    value={lastname}
                    onChange={(e) => onLastNameChange(e)}
                  />
                  {Validationerrors.lastnameerror ? (
                    <>
                      {Validationerrors.lastnameerror.type === "required" && (
                        <span className="error-msg">
                          {Validationerrors.lastnameerror.message}
                        </span>
                      )}
                      {Validationerrors.lastnameerror.type === "minLength" && (
                        <span className="error-msg">
                          {Validationerrors.lastnameerror.message}
                        </span>
                      )}
                    </>
                  ) : null}
                </div>

              </div>
            </div>



            <div className="row">
              <div className="col-12 col-md-6">
                <div className="field">
                  <input
                    type="text"
                    className="form-control inputTextBox"
                    placeholder="Email*"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => onEmailChanges(e)}
                    onBlur={handleBlur}
                    pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                    required
                  />
                  {Validationerrors.emailerror ? (
                    <>
                      {Validationerrors.emailerror.type === "required" && (
                        <span className="error-msg">
                          {Validationerrors.emailerror.message}
                        </span>
                      )}
                      {Validationerrors.emailerror.type === "minLength" && (
                        <span className="error-msg">
                          {Validationerrors.emailerror.message}
                        </span>
                      )}
                    </>
                  ) : null}
                </div>

              </div>
              <div className="col-12 col-md-6">
                <div className="field">
                  <DatePicker
                    showIcon
                    selected={dob}
                    onChange={(date) => {
                      setdob(date);
                    }}
                    placeholderText="Date of Birth*"
                    dropdownMode="select"
                    maxDate={maxDate}
                    minDate={minDate}
                    showMonthDropdown
                    showYearDropdown
                    adjustDateOnChange
                    dateFormat="dd/MM/yyyy"
                  />
                  {Validationerrors.doberror ? (
                    <>
                      {Validationerrors.doberror.type === "required" && (
                        <span className="error-msg">
                          {Validationerrors.doberror.message}
                        </span>
                      )}
                      {Validationerrors.doberror.type === "minLength" && (
                        <span className="error-msg">
                          {Validationerrors.doberror.message}
                        </span>
                      )}
                    </>
                  ) : null}

                </div>


              </div>
            </div>






            <div className="gropField">
              <label htmlFor="tenthPercentage" className="group-label">Percentage of marks: </label>
              <div className="row">
                <div className="col-6">
                  <div className="filed">
                    <input
                      type="number"
                      className="form-control percentInput"
                      placeholder="Class 10th*"
                      id="tenthPercentage"
                      name="tenthPercentage"
                      maxLength={"2"}
                      onInput={(e) => (e.target.value = e.target.value.slice(0, 2))}
                      onChange={(e) => {
                        const value = e.target.value;
                        setTenPercentage(value);

                        if (!value) {
                          setErrors((prev) => ({
                            ...prev,
                            tenpercentageerror: {
                              type: "required",
                              message: "Class 10th percentage is required",
                            },
                          }));
                        } else {
                          setErrors((prev) => ({
                            ...prev,
                            tenpercentageerror: {},
                          }));
                        }
                      }}
                      disabled={disableFields}
                    />

                    {tenpercentage ? <span className="percentSuffix">% in Class 10th</span> : null}

                    {Validationerrors.tenpercentageerror ? (
                      <>
                        {Validationerrors.tenpercentageerror.type === "required" && (
                          <span className="error-msg">
                            {Validationerrors.tenpercentageerror.message}
                          </span>
                        )}
                        {Validationerrors.tenpercentageerror.type === "minLength" && (
                          <span className="error-msg">
                            {Validationerrors.tenpercentageerror.message}
                          </span>
                        )}
                      </>
                    ) : null}
                  </div>


                </div>

                <div className="col-6">
                  <div className="filed">
                    <input
                      type="number"
                      className="form-control percentInput"
                      placeholder="Class 12th*"
                      id="twelvePercentage"
                      name="twelvePercentage"
                      maxLength={"2"}
                      onInput={(e) => (e.target.value = e.target.value.slice(0, 2))}
                      onChange={(e) => setTwelvePercentage(e.target.value)}
                      disabled={disableFields}
                    />
                    {twelvepercentage ? (
                      <span className="percentSuffix">% in Class 12th</span>
                    ) : null}

                    {Validationerrors.twelvepercentageerror?.error && (
                      <span className="error-msg">
                        {Validationerrors.twelvepercentageerror.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="gropField">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="filed">
                    <div className="Grad">
                      <span>Graduation*</span>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="graduationStatus"
                          id="graduationYes"
                          value="Yes"
                          checked={Garduation === "Yes"}
                          onChange={handleGraduationBox}
                        />
                        <label className="form-check-label" htmlFor="graduationYes">
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="graduationStatus"
                          id="graduationNo"
                          value="No"
                          checked={Garduation === "No"}
                          onChange={handleGraduationBox}
                        />
                        <label className="form-check-label" htmlFor="graduationNo">
                          No
                        </label>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="filed">
                    <input
                      type="number"
                      className="form-control percentInput"
                      placeholder="% of marks in Graduation*"
                      id="percentage"
                      name="percentage"
                      maxLength={"2"}
                      onInput={(e) => (e.target.value = e.target.value.slice(0, 2))}
                      onChange={(e) => {
                        const value = e.target.value;
                        onPercentageChanges(e); // keep your existing logic

                        if (!value) {
                          setErrors((prev) => ({
                            ...prev,
                            percentageerror: {
                              type: "required",
                              message: "Graduation percentage is required",
                            },
                          }));
                        } else {
                          setErrors((prev) => ({
                            ...prev,
                            percentageerror: {},
                          }));
                        }
                      }}
                      disabled={disableFields}
                    />

                    {percentage ? <span className="percentSuffix">% in Graduation</span> : null}

                    {Validationerrors.percentageerror ? (
                      <>
                        {Validationerrors.percentageerror.type === "required" && (
                          <span className="error-msg">
                            {Validationerrors.percentageerror.message}
                          </span>
                        )}
                        {Validationerrors.percentageerror.type === "minLength" && (
                          <span className="error-msg">
                            {Validationerrors.percentageerror.message}
                          </span>
                        )}
                      </>
                    ) : null}
                  </div>


                </div>
              </div>
            </div>




            {/* 
              <div className="field">
                <select
                  name="entity"
                  className="form-control"
                  onChange={(e) => onStreamChanges(e)}
                  disabled={disableFields}
                >
                  <option value="">Select Graduation Type*</option>
                  <option value="BA-FT">BA-FT</option>
                  <option value="B.Com">B.Com</option>
                  <option value="B.E">B.E</option>
                  <option value="BTECH-FT">BTECH-FT</option>
                  <option value="Others">Others</option>
                </select>
                {Validationerrors?.GraduationStreamerror ? (
                  <>
                    {Validationerrors.GraduationStreamerror.type ===
                      "required" && (
                      <span className="error-msg">
                        {Validationerrors.GraduationStreamerror.message}
                      </span>
                    )}
                  </>
                ) : null}
              </div> */}


            <div className="gropField">
              <label htmlFor="experienceYears" className="group-label">Select Experience: </label>
              <div className="row">
                <div className="col-6">
                  <div className="filed">
                    <select
                      name="experienceYears"
                      id="experienceYears"
                      className="form-control"
                      value={experienceYears}
                      onChange={(e) => setExperienceYears(e.target.value)}
                    >
                      <option value=""> Years*</option>
                      {[...Array(13)].map((_, index) => (
                        <option key={index} value={index}>
                          {index} {index === 1 ? "year" : "years"}
                        </option>
                      ))}
                    </select>

                    {Validationerrors?.ExperienceYearserror?.error && (
                      <span className="error-msg">
                        {Validationerrors.ExperienceYearserror.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-6">
                  <div className="filed">
                    <select
                      name="experienceMonths"
                      className="form-control"
                      aria-label="experienceYears"
                      value={experienceMonths}
                      onChange={(e) => setExperienceMonths(e.target.value)}
                    >
                      <option value="">Months *</option>
                      {[...Array(12)].map((_, index) => (
                        <option key={index} value={index}>
                          {index} {index === 1 ? "month" : "months"}
                        </option>
                      ))}
                    </select>

                    {Validationerrors?.ExperienceMonthserror?.error && (
                      <span className="error-msg">
                        {Validationerrors.ExperienceMonthserror.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>






            <div className="field">
              <input
                type="number"
                className="form-control"
                placeholder="Current pincode*"
                id="pincode"
                name="pincode"
                pattern="\d*"
                maxLength={"6"}
                onInput={(e) => (e.target.value = e.target.value.slice(0, 6))}
                onChange={(e) => setPincode(e.target.value)}
                disabled={disableFields}
              />
              {Validationerrors.pincodeerror ? (
                <>
                  {Validationerrors.pincodeerror.type === "required" && (
                    <span className="error-msg">
                      {Validationerrors.pincodeerror.message}
                    </span>
                  )}
                  {Validationerrors.pincodeerror.type === "minLength" && (
                    <span className="error-msg">
                      {Validationerrors.pincodeerror.message}
                    </span>
                  )}
                </>
              ) : null}
            </div>

            <div className="mobileotp">
              <div className="inputotp field">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Mobile No.*"
                  id="mobile"
                  name="mobile"
                  maxLength={"10"}
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 10))
                  }
                  disabled={disableFields}
                  //  onChange={(e)=> {setmobileNo(e.target.value);setOtpVerified(false);setSeconds(0);setOtpStatus(false)}}
                  onChange={(e) => {
                    let input = e.target.value;
                    input = input.replace(/\D/g, "");
                    if (/^[6-9]\d{0,9}$/.test(input)) {
                      if (input.length > 10) {
                        input = input.slice(0, 10);
                      }
                      setmobileNo(input);
                      setOtpVerified(false);
                      setSeconds(0);
                      setOtpStatus(false);
                      setErrors({
                        mobileerror: {
                          error: false,
                          message: "",
                          type: "",
                        },
                      });
                    } else {
                      setErrors({
                        mobileerror: {
                          error: true,
                          message:
                            "Please enter mobile number starting with 6/7/8/9.",
                          type: "required",
                        },
                      });
                      setmobileNo();
                    }
                  }}
                />
                {Validationerrors.mobileerror ? (
                  <>
                    {Validationerrors.mobileerror.type === "required" && (
                      <span className="error-msg">
                        {Validationerrors.mobileerror.message}
                      </span>
                    )}
                    {Validationerrors.mobileerror.type === "minLength" && (
                      <span className="error-msg">
                        {Validationerrors.mobileerror.message} 1
                      </span>
                    )}
                  </>
                ) : null}
              </div>


              <div className="getotp">
                {otpStatus && seconds > 0 && !otpVerified ? (
                  <div
                    className="form-input"
                    style={{ display: "-webkit-inline-box" }}
                  >
                    <input
                      type="text"
                      className="form-control inputTextBox input--otp-box"
                      name="otpInput"
                      min="0"
                      ref={inputOtpReference}
                      maxLength={6}
                      autoComplete="off"
                      placeholder="Enter OTP"
                      disabled={disableStatus}
                      onKeyPress={(e) => onOtpKeyHandler(e)}
                      onChange={(e) => verifyOtp(e.target.value)}
                      {...register("otpInput", {
                        required: "Please enter OTP",
                        minLength: {
                          value: 6,
                          message: "Please enter at least 6 characters.",
                        },
                        onChange: (e) => verifyOtp(e),
                      })}
                    />
                    {!otpVerified && seconds > 0 && (
                      <span className="otp_field">
                        00 :{seconds < 10 ? `0${seconds}` : seconds}
                      </span>
                    )}
                  </div>
                ) : null}

                {otpVerified == false ? (
                  <>
                    <span className="error-msg">
                      {
                        "A One-Time-Password (OTP) is required to verify your mobile number."
                      }
                    </span>
                  </>
                ) : null}
              </div>

              <div className="field">
                {!otpVerified && (
                  <div className="otpbtn">
                    {otpStatus == false && seconds == 0 && (
                      <a
                        href="#!"
                        onClick={() => sendOtp(mobileNo)}
                        disabled={disableStatus || disableFields}
                        style={disableFields ? { background: "gray" } : {}}
                      >
                        Get OTP
                      </a>
                    )}
                    {otpStatus == true && seconds == 0 && (
                      <a
                        href="#!"
                        onClick={(eve) => {
                          sendOtp(mobileNo);
                        }}
                      >
                        Resend OTP
                      </a>
                    )}
                  </div>
                )}
                {Validationerrors.othererror ? (
                  <>
                    {Validationerrors.othererror.type === "required" && (
                      <span
                        className="error-msg"
                        style={{ left: "-60px", top: "-40px" }}
                      >
                        {Validationerrors.othererror.message}
                      </span>
                    )}
                  </>
                ) : null}
              </div>
            </div>

            {/* <div className="form-check authori field">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="chkauthorize"
                  name="terms"
                  defaultChecked={Terms}
                  onChange={(e) => Onsetterms(e)}
                />
                <label className="form-check-label" htmlFor="chkauthorize">
                  I agree to receive communications related to the ICICI Bank’s
                  recruitment process through SMS, WhatsApp , Email, Phone
                  Calls, and Social Media.
                </label>
                <br />
                <br />
                {Validationerrors.termserror ? (
                  <>
                    {Validationerrors.termserror.type === "required" && (
                      <span className="error-msg">
                        {Validationerrors.termserror.message}
                      </span>
                    )}
                  </>
                ) : null}
              </div>
              <div className="form-check authori field">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="chkauthorize"
                  name="terms"
                  defaultChecked={Terms}
                  onChange={(e) => Onsetterms(e)}
                />
                <label className="form-check-label" htmlFor="chkauthorize">
                  I authorize ICICI Bank to store / share / exchange / transfer
                  / process data within ICICI Bank / authorized third-party
                  service providers / any other person as may be
                  necessary/required by ICICI Bank for the purpose of
                  recruitment.
                </label>
                <br />
                <br />
                {Validationerrors.termserror ? (
                  <>
                    {Validationerrors.termserror.type === "required" && (
                      <span className="error-msg">
                        {Validationerrors.termserror.message}
                      </span>
                    )}
                  </>
                ) : null}
              </div> */}
            {/* <div className="Grad authori field">
                <span>
                  I agree to receive communications related to the ICICI Bank’s
                  recruitment process through SMS, WhatsApp, Email, Phone Calls,
                  and Social Media.*
                </span>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="communicationConsent"
                    id="communicationConsentYes"
                    value="Yes"
                    checked={communicationConsent === "Yes"}
                    onChange={(e) => setCommunicationConsent(e.target.value)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="communicationConsentYes"
                  >
                    Yes
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="communicationConsent"
                    id="communicationConsentNo"
                    value="No"
                    checked={communicationConsent === "No"}
                    onChange={(e) => setCommunicationConsent(e.target.value)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="communicationConsentNo"
                  >
                    No
                  </label>
                </div>

                {Validationerrors?.communicationConsentError?.error && (
                  <span className="error-msg">
                    {Validationerrors.communicationConsentError.message}
                  </span>
                )}
              </div>
              <div className="Grad authori field">
                <span>
                  I authorize ICICI Bank to store / share / exchange / transfer
                  / process data within ICICI Bank / authorized third-party
                  service providers / any other person as may be
                  necessary/required by ICICI Bank for the purpose of
                  recruitment.*
                </span>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dataProcessingConsent"
                    id="dataProcessingConsentYes"
                    value="Yes"
                    checked={dataProcessingConsent === "Yes"}
                    onChange={(e) => setDataProcessingConsent(e.target.value)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="dataProcessingConsentYes"
                  >
                    Yes
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dataProcessingConsent"
                    id="dataProcessingConsentNo"
                    value="No"
                    checked={dataProcessingConsent === "No"}
                    onChange={(e) => setDataProcessingConsent(e.target.value)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="dataProcessingConsentNo"
                  >
                    No
                  </label>
                </div>

                {Validationerrors?.dataProcessingConsentError?.error && (
                  <span className="error-msg">
                    {Validationerrors.dataProcessingConsentError.message}
                  </span>
                )}
              </div> */}
            {/* Disclaimer 1 */}
            <div className="authori field form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="communicationConsent"
                id="communicationConsentYes"
                checked={communicationConsent}
                onChange={(e) => setCommunicationConsent(e.target.checked)}
              />

              <label className="form-check-label" htmlFor="communicationConsentYes">
                I agree to receive communications related to the ICICI Bank’s
                recruitment process through SMS, WhatsApp, Email, Phone Calls,
                and Social Media.*
              </label>

              {Validationerrors?.communicationConsentError?.error && (
                <span className="error-msg">
                  {Validationerrors.communicationConsentError.message}
                </span>
              )}
            </div>

            {/* Disclaimer 2 */}
            <div className="authori field form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="dataProcessingConsent"
                id="dataProcessingConsentYes"
                checked={dataProcessingConsent}
                onChange={(e) => setDataProcessingConsent(e.target.checked)}
              />

              <label className="form-check-label" htmlFor="dataProcessingConsentYes">
                I authorize ICICI Bank to store / share / exchange / transfer
                / process data within ICICI Bank / authorized third-party
                service providers / any other person as may be
                necessary/required by ICICI Bank for the purpose of
                recruitment.*
              </label>

              {Validationerrors?.dataProcessingConsentError?.error && (
                <span className="error-msg">
                  {Validationerrors.dataProcessingConsentError.message}
                </span>
              )}
            </div>


            <button
              className="applybtn"
              type="button"
              onClick={handleSubmit(onSubmitForm)}
              // disabled={applyNow && otpVerified}
              disabled={(applyNow && otpVerified) || !consentYes}
              style={{
                // background: applyNow && otpVerified ? "gray" : "#e3530f",
                background:
                  (applyNow && otpVerified) || !consentYes
                    ? "gray"
                    : "#e3530f",
              }}
            >
              {applyNow && otpVerified ? "Processing.." : "Apply Now"}{" "}
            </button>
          </div>
        </div>
      </form>
      <ToastContainer />
    </>
  );
};

export default FormComponent;
